module.exports = __tmimport("widgets/spinner");